/* eslint-disable prefer-destructuring */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import { connect } from 'react-redux';
import Moment from 'moment';
import ReactHtmlParser from 'react-html-parser';
import CityName from '../../commons/iataRenderService';
import Precio from './precio';
import './detalle.css';

const iconoHomologado = {
  vuelo: 'fa fa-plane',
  asistencia: 'fa fa-medkit',
  traslados: 'fa fa-car',
  hotel: 'fa fa-bed',
  excursiones: 'fa fa-ticket ',
  auto: 'fa fa-car',
  guia: 'fa fa-map',
};

class Detalle extends Component {
  /* eslint-disable */
  generarIconosServicios() {
    if (this.props.paquete.salidas[0] !== undefined) {
      if (this.props.paquete.salidas[0].tipoServicios === !null || this.props.paquete.salidas[0].tipoServicios.length > 0) {
        const servicios = this.props.paquete.salidas[0].tipoServicios;
        return servicios.map((servicioId, indice) => {
          const icono = this.props.paquete.proveedorId === 1 ? `fa ${servicioId}` : iconoHomologado[servicioId];
          return (
            <span key={icono} className='icon-container-rounded color-dinamico-fondo'>
              <i className={icono} data-toggle='tooltip' />
            </span>
          );
        });
      }
    }
  }

  renderStar = (quantity) => {
    if (quantity === 0) return null;

    const stars = [1, 2, 3, 4, 5];
    return (
      <span className='stars-container'>
        {stars.map((currentValue) => {
          const className =
          currentValue <= quantity ?
            'fa fa-star yellow' :
            'fa fa-star icon-gray';
          return (
            <div className='inline' key={currentValue}>
              <i className={className} aria-hidden='true' />
            </div>
          );
        })}
      </span>
    );
  }

  armarUrl = () => {
    const urlString = isClient ? window.location.href : '';
    return new URL(urlString);
  }

  render() {
    const { paquete } = this.props;
    let hotelList = '';
    let dropDownHoteles = '';
    if (paquete.salidas[0].hoteles.length > 0) {
      const { hoteles } = this.props.paquete.salidas[0];
      const primerHotel = (
        <div className='hotel-item-container'>
          <div className='hotel'>
            <span className='nombre-hotel'>
              {hoteles[0].nombre}
&nbsp;
            </span>
            {this.renderStar(hoteles[0].clase)}
          </div>
          <div className='habitacion'>
            {hoteles[0].tipoHabitacion !== null ?
              (this.props.paquete.proveedorId !== 1 ?
                `HAB. ${hoteles[0].tipoHabitacion.replace('|', ' | ')}` :
                `HAB. ${hoteles[0].tipoHabitacion}`) :
              (null)}
            {' '}
            {hoteles[0].regimen !== null ?
              (<span className='regimen'>{hoteles[0].regimen}</span>) :
              (null)}
          </div>
        </div>
      );
      if (hoteles.length > 1) {
        hotelList = hoteles.filter((hotel, index) => {
          return index !== 0;
        }).map((hotel, indice) => {
          return (
            <li key={indice}>
              <div className='hotel'>
                {hotel.nombre}
                {this.renderStar(hotel.clase)}
              </div>
              <div className='habitacion'>
                {hotel.tipoHabitacion !== null ?
                  (this.props.paquete.proveedorId !== 1 ? `HAB. ${hotel.tipoHabitacion.replace('|', '')}` : `HAB. ${hotel.tipoHabitacion}`) :
                  (null)}
                {' '}
                {hotel.regimen !== null ?
                  (<span className='regimen'>{hotel.regimen}</span>) :
                  (null)}
              </div>
            </li>
          );
        });
      }
      dropDownHoteles = (
        <div className='dropdown hotels-trigger'>
          <a
            className='dropdown-toggle'
            type='button'
            id='dropdownMenu-hoteles'
            data-toggle='dropdown'
            aria-haspopup='true'
            aria-expanded='true'
          >
            {primerHotel}
            <div className='ver-mas-hoteles color-dinamico'>
              {hotelList.length > 0 ? (
                <React.Fragment>
                  <i className='fa fa-chevron-down' aria-hidden='true' />
&nbsp; Ver otros
                  {' '}
                  {hotelList.length}
                  {' '}
hoteles
                  {' '}
                </React.Fragment>
              ) :
                null}
            </div>
          </a>
          {hotelList.length > 0 ?
            (
              <ul
                className='dropdown-menu'
                aria-labelledby='dropdownMenu-hoteles'
              >
                {hotelList}
              </ul>
            ) :
            null
          }
        </div>
      );
    }

    //Valida fecha salida si el proveedor es allSeasons, ya que puede ser por rango de fechas//
    const mobile = isClient ? window.innerWidth <= 768 : false;
    const formatoDia = mobile ? 'ddd D' : 'dddd D';
    const formatoMes = mobile ? 'MMM' : 'MMMM';
    let salida;

    if (paquete.proveedorId === 3) {
      if (this.props.paquete.salidas[0].uniqueOperationDate) {
        salida = `Salida ${
          Moment(this.props.paquete.salidas[0].operationDate).format(formatoDia)
        } de ${
          Moment(this.props.paquete.salidas[0].operationDate).format(formatoMes)}`;
      } else {
        const fechaDesde = Moment(this.props.paquete.salidas[0].fechaSalida).format('DD/MM/YYYY');
        const fechaHasta = Moment(this.props.paquete.salidas[0].fechaLlegada).format('DD/MM/YYYY');
        salida = `${'Salida DESDE '}${fechaDesde} HASTA ${fechaHasta}`;
      }
    } else {
      salida = `Salida ${
        Moment(this.props.paquete.salidas[0].fechaSalida).format(formatoDia)
      } de ${
        Moment(this.props.paquete.salidas[0].fechaSalida).format(formatoMes)}`;
    }
    //Valida fecha salida si el proveedor es allSeasons, ya que puede ser por rango de fechas//

    const origen = paquete.salidas[0].origen === paquete.salidas[0].origenIata ?
      (<CityName code={paquete.salidas[0].origenIata} upperCase='false' />) :
      paquete.salidas[0].origen;

    const idOrigen = paquete.salidas[0].origenIata ? paquete.salidas[0].origenIata : '';

    const referencia =
      paquete.salidas[0].referencia.externa !== '' && paquete.salidas[0].referencia.externa ?
        paquete.salidas[0].referencia.externa :
        (parseInt(paquete.proveedorId) === 1) ? paquete.salidas[0].id : paquete.salidas[0].referencia.interna;

    const cantPasajeros = paquete.pasajeros.length > 0 && paquete.pasajeros ?
      paquete.pasajeros.length :
      this.props.cantidadPasajeros;

    const iva = paquete.salidas[0].precios.iva ?
      paquete.salidas[0].precios.iva :
      0;

    const currencyDefault = this.props.application.currency.code;
    const precio = this.props.formatearPrecio(
      currencyDefault === 'USD' && paquete.salidas[0].precios.precioNetoDolares != null ?
        paquete.salidas[0].precios.precioNetoDolares :
        paquete.salidas[0].precios.precioNeto,
      currencyDefault === 'USD' && paquete.salidas[0].precios.impuestosDolares != null ?
        paquete.salidas[0].precios.impuestosDolares :
        paquete.salidas[0].precios.impuestos,
      currencyDefault === 'USD' ?
        0 :
        paquete.salidas[0].precios.impuestoPais,
      currencyDefault === 'USD' && paquete.salidas[0].precios.ivaDolares != null ?
        paquete.salidas[0].precios.ivaDolares :
        iva,
      cantPasajeros,
    );

    const destino = isClient ? window.location.pathname : ''.split('/')[4];

    const titulo = parseInt(paquete.proveedorId) === 4 ?
      <CityName code={destino} fullName='true' /> :
      parseInt(paquete.proveedorId) === 10 ? this.props.title.replace(/\((.*?)\)/g, '') : this.props.title ;

    let { cupos } = paquete.salidas[0];
    cupos = cupos !== 0 ? `${cupos} lugares` : 'Consultar Disponibilidad';

    let imagen = paquete.proveedorId === 3 ?
      paquete.imagen.split(';')[0] :
      paquete.imagen ?
        paquete.proveedorId === 2 ?
          paquete.imagen.replace('https://www.ola.com.ar//www.ola.com.ar', 'https://www.ola.com.ar') :
          paquete.imagen :
        paquete.imagen;

    if (imagen === '' || imagen === null || imagen === undefined) {
      if (paquete.salidas[0].hoteles.length > 0) {
        if (paquete.salidas[0].hoteles[0].imagenes) {
          if (paquete.salidas[0].hoteles[0].imagenes.length > 0) {
            imagen = paquete.salidas[0].hoteles[0].imagenes[0];
          }
        }
      }
    }
    imagen = imagen == null || imagen === undefined ? 'https://res.mundigea.com.ar/img/recursos/paquete.jpg' : imagen;

    if (imagen.includes('res.cloudinary')) {
      imagen = imagen.replace('upload/', 'upload/c_fill,q_auto:low/');
    }

    return (
      <React.Fragment>
        <div className='col-lg-4 col-md-4'>
          <div className='row'>

            <div className='cupos-imagen color-dinamico-fondo'>{cupos}</div>
            <img
              style={{ width: '100%', height: 239, objectFit: 'cover' }}
              src={imagen}
              alt='Img de tu destino'
            />
          </div>
        </div>
        <div className='col-lg-5 col-md-5'>
          <div className='detalle'>
            <div className='nombre'>
              {paquete.proveedorId !== 4 ? ReactHtmlParser(titulo) : titulo}
            </div>
            <div className='noches'>
              {paquete.cantNoches}
              {' '}
              noches
            </div>
            <div className='lista-hoteles'>
              {dropDownHoteles}
            </div>
            <div className='servicios'>
              {this.generarIconosServicios()}
            </div>
            <div className='salida'>
              <span>
                {ReactHtmlParser(salida)}
                {' '}
Desde
                {origen}
              </span>
            </div>
          </div>
        </div>
        <div className='col-lg-3 col-md-3'>
          <Precio
            idOrigen={idOrigen}
            idDestino={paquete.salidas[0].destinoIata}
            idProducto={paquete.idProducto}
            proveedorId={this.props.proveedorId}
            distribucion={this.props.distribucion}
            title={this.props.title}
            salidas={this.props.salidas}
            referencia={referencia}
            cantPasajeros={cantPasajeros}
            precio={precio}
            indice={this.props.indice}
            appId={paquete.applicationId}
            nroComb={paquete.nroComb}
          />
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  application: state.applicationState,
});

export default connect(mapStateToProps, null)(Detalle);
